<template>
  <div v-if="item">
    <div v-for="(teach_day, index) in item.teach_days" :key="index">
      <div>
        <span class="teach-time">
          {{ teach_day.dayjs_sample_start.locale(lang).format("dddd HH:mm") }} -
          {{ teach_day.dayjs_sample_end.format("HH:mm") }}
          <v-btn
            v-if="show_timeslot_dropdown === true"
            icon
            color="deep-orange"
            @click="show_item_detail(item)"
          >
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </span>
      </div>
    </div>
    <div>
      <v-chip class="ma-2 white--text ma-0" color="indigo" width="100" x-small>
        Midterm
      </v-chip>
      <span
        class="indigo--text font-weight-bold"
        v-if="item.midterm_start_date_time"
      >
        {{
          item.midterm_start_date_time
            .locale(lang)
            .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"} HH:mm`)
        }}
        - {{ item.midterm_end_date_time.format("HH:mm") }}
      </span>
      <span class="indigo--text font-weight-bold" v-else>{{
        $t("pre_regis_add_subject.defined_by_instructor")
      }}</span>
    </div>
    <div>
      <v-chip class="ma-2 white--text ma-0" color="deep-orange" x-small>
        Final
      </v-chip>
      <span
        class="deep-orange--text font-weight-bold"
        v-if="item.final_start_date_time"
      >
        {{
          item.final_start_date_time
            .locale(lang)
            .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"} HH:mm`)
        }}
        - {{ item.final_end_date_time.format("HH:mm") }}
      </span>
      <span class="deep-orange--text font-weight-bold" v-else>{{
        $t("pre_regis_add_subject.defined_by_instructor")
      }}</span>
    </div>

    <v-dialog v-model="time_slot_dialog" scrollable max-width="500">
      <v-card v-if="showing_item">
        <v-card-title
          >{{ $t("pre_regis_add_subject.subject_id") }}:
          {{ showing_item.subject_id }}</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <h1 class="mt-2 deep-orange--text">
            {{ showing_item.subject_tname }}
          </h1>
          <h2 class="brown--text">
            {{ showing_item.subject_ename }}
          </h2>
          <h2 class="mt-2 mb-2">
            {{ $t("pre_regis_add_subject.section") }} :
            {{ showing_item.section }}
          </h2>
          <div
            v-for="(item, index) in showing_item.time_slot"
            :key="index"
            class="text-center"
          >
            {{
              dayjs(item.START_DATE_TIME, "YYYY-MM-DD HH:mm:ss")
                .locale(lang)
                .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"} HH:mm`)
            }}
            -
            {{
              dayjs(item.END_DATE_TIME, "YYYY-MM-DD HH:mm:ss")
                .locale(lang)
                .format("HH:mm")
            }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="time_slot_dialog = false">
            {{ $t("pre_regis_add_subject.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as dayjs from "dayjs";
require("dayjs/locale/th");

export default {
  name: "TeachAndExamTime",
  props: {
    item: {
      type: Object,
      default: null,
    },
    show_timeslot_dropdown: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    showing_item: null,
    time_slot_dialog: false,
  }),
  computed: {
    lang() {
      if (this.$root.$i18n.locale) return this.$root.$i18n.locale;
      return "th";
    },
  },
  methods: {
    dayjs,
    // lect_prac_lang(data) {
    //   if (this.$root.$i18n.locale === "en") {
    //     if (data === "ท") return "L";
    //     else return "P";
    //   }
    //   return data;
    // },
    show_item_detail(item) {
      this.showing_item = item;
      this.time_slot_dialog = true;
    },
  },
};
</script>

<style>
.teach-time {
  display: inline-flex;
  height: 36px;
  align-items: center;
}
</style>
